import React, { useState } from "react";
import { Badge, Alert } from "react-bootstrap";
import { CommonButton, CommonInput } from "../../Input";
import DataTable from "../../table/DataTable";

const Step2ReceiverList = ({ selectedReceivers, onToggleReceiver }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const mockData = [
    {
      id: "8397",
      name: "SparkMinds check duplicate name",
      contactNo: "+65 1231 231 2318",
      receiverType: "Individual",
      relationship: "Related company",
      bank: "ASIA UNITED BANK",
      correspondenceBank: "--",
      deliveryMethod: "Bank Transfer",
      createdDate: "10/03/2026\n17:07:18",
      status: "--",
    },
    {
      id: "8377",
      name: "Thuynga Check level limit",
      contactNo: "+65 1234 567 8900",
      receiverType: "Organization",
      relationship: "Customer",
      bank: "OMNIPAY, INC.",
      correspondenceBank: "--",
      deliveryMethod: "Bank Transfer",
      createdDate: "08/03/2026\n11:09:48",
      status: "Approved",
    },
    {
      id: "8375",
      name: "Thuy Nga Check limit",
      contactNo: "+65 1234 567 8901",
      receiverType: "Individual",
      relationship: "Spouse",
      bank: "OMNIPAY, INC.",
      correspondenceBank: "--",
      deliveryMethod: "Bank Transfer",
      createdDate: "06/03/2026\n17:54:15",
      status: "Approved",
    },
  ];

  const columns = [
    { label: "ID", key: "id", className: "ps-4" },
    {
      label: "Name",
      key: "name",
      className: "ps-4",
    },
    {
      label: "Contact No",
      key: "contactNo",
      className: "ps-4",
    },
    {
      label: "Receiver Type",
      key: "receiverType",
      className: "ps-4",
    },
    {
      label: "Relationship",
      key: "relationship",
      className: "ps-4",
    },
    { label: "Bank", key: "bank", className: "ps-4" },
    {
      label: "Correspondence Bank",
      key: "correspondenceBank",
      className: "ps-4",
    },
    {
      label: "Delivery Method",
      key: "deliveryMethod",
      className: "ps-4",
    },
    {
      label: "Created Date",
      key: "createdDate",
      cellStyle: () => ({ whiteSpace: "pre-line" }),
      cellClassName: " fs-12",
      className: "ps-4",
    },
    {
      label: "Status",
      key: "status",
      className: "ps-4",
      render: (item) =>
        item.status !== "--" ? (
          <Badge
            bg="success"
            className="bg-opacity-10 text-success border-0 px-2 py-1"
          >
            {item.status}
          </Badge>
        ) : (
          <span className="text-muted">--</span>
        ),
    },
  ];

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = mockData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <div className="d-flex align-items-end mb-4 gap-2">
        <div style={{ width: "250px" }}>
          <CommonInput label={"Name"} placeholder="Enter receiver name" />
        </div>
        <CommonButton
          variant="outline"
          style={{ width: "50px", height: "50px", minWidth: "50px" }}
          className="p-0 d-flex align-items-center justify-content-center rounded-circle"
        >
          <i className="flaticon-381-repeat-1 fs-16"></i>
        </CommonButton>
        <CommonButton
          className="p-0 d-flex align-items-center justify-content-center"
          style={{ width: "50px", height: "50px", minWidth: "50px" }}
        >
          <i className="flaticon-381-search-1 fs-18 text-white"></i>
        </CommonButton>
      </div>

      <div className="card border-0 shadow-sm rounded-4 mb-4">
        <div className="card-body">
          <DataTable
            columns={columns}
            data={currentItems}
            totalItems={mockData.length}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            paginate={paginate}
            showPagination={true}
            rowClassName={(item) =>
              selectedReceivers.includes(item.id)
                ? "bg-light-blue cursor-pointer"
                : "cursor-pointer"
            }
            onRowClick={(item) => onToggleReceiver(item)}
            minWidth="1200px"
          />
        </div>
      </div>
    </>
  );
};

export default Step2ReceiverList;
